// Preview render polling state machine, extracted from the clip-builder
// controller. Kicks off a first status check after `firstDelay`, then repolls
// every `interval` until the render completes, fails, or `maxAttempts` is hit.
//
// Timing and attempt count match the original inline implementation (first
// check at 3s, 4s cadence, 30 attempts ~= 2 minutes). Pure of Stimulus and
// DOM — the caller injects a `fetchStatus` thunk and outcome callbacks, so it
// is fully testable with fake timers.

export function pollPreviewStatus({
  fetchStatus,
  onComplete,
  onFailed,
  onTimeout,
  onError,
  firstDelay = 3000,
  interval = 4000,
  maxAttempts = 30,
} = {}) {
  let attempts = 0

  const poll = async () => {
    attempts += 1
    try {
      const data = await fetchStatus()

      if (data.status === "completed" && data.video_url) {
        onComplete?.(data.video_url)
        return
      }

      if (data.status === "failed") {
        onFailed?.()
        return
      }

      if (attempts < maxAttempts) {
        setTimeout(poll, interval)
      } else {
        onTimeout?.()
      }
    } catch {
      onError?.()
    }
  }

  setTimeout(poll, firstDelay)
}
